export default __webpack_public_path__ + "static/media/cherry_swashregular.10d89162.txt";